import React, { Component } from "react";
import "../../node_modules/bootstrap/js/src/collapse";
import "../../node_modules/jquery/src/jquery";
import { withRouter, Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import $ from "jquery";
const DICon = require("../assets/icons-pack/detasad-D-icon.svg");

const logo = require("../assets/images/logo.png");
/* eslint-disable */
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: false,
            showProducts: false,
            showSolutions: false,
            showPartners: false,
        };
    }
    componentDidMount() {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({ mobile: true, showProducts: true, showPartners: true, showSolutions: true });
        }
    }

    render() {
        const { mobile, showProducts, showSolutions, showPartners } = this.state;
        $(window).scroll(function () {
            var sticky = $(".fixed"),
                scroll = $(window).scrollTop();
            if (scroll >= 20) sticky.addClass("sticky");
            else sticky.removeClass("sticky");
        });
        return (
            <React.Fragment>
                <div className=" container-fluid">
                    <Row className="text-align-center">
                        <Col className="info-class" md="4" sm="12">
                            <Link className="navbar-brand main-heading" to="/">
                                {" "}
                                <img src={logo} alt="Logo" className="brand-logo"/>{" "}
                            </Link>
                        </Col>
                        <Col className="contact-lang info-buttons offset-4" md="4" sm="12">
                            <div className="right-buttons">
                                <button
                                    className="btn btn-sm custom-text bordered marketplace-btn"
                                    onClick={() => window.open('https://detacloud.detasad.com/', "_blank")}
                                >
                                    Marketplace
                                </button>
                                <button
                                    className="btn btn-sm custom-text"
                                    // onClick={() => window.open(process.env.REACT_APP_CONSOLE, "_blank")}
                                >
                                    
                                    <a href="mailto:detacloud@detasad.com"><i className="fa fa-envelope">
                                        <span className="font-aller">detacloud@detasad.com</span>
                                    </i></a>

                                </button>
                                {/* <button
                                    className="btn btn-sm custom-text"
                                    // onClick={() => window.open(process.env.REACT_APP_SIGNUP, "_blank")}
                                >
                                    <i className="fa fa-globe">
                                        <span className="font-aller">English</span>
                                    </i>
                                </button> */}
                            </div>
                        </Col>
                    </Row>
                </div>
                <nav className="navbar navbar-expand-lg navbar-dark nav-custom-bg custom-nav fixed">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item mobile-hide">
                                <img src={DICon} />
                            </li>
                            <li className="nav-item  dropdown position-static">
                                <Link
                                    to="#"
                                    onClick={() =>
                                        this.setState({
                                            showProducts: mobile ? !this.state.showProducts : this.state.showProducts
                                        })
                                    }
                                    className={
                                        !showProducts
                                            ? "nav-link text-white  dropdown-toggle"
                                            : "text-white  dropdown-toggle"
                                    }
                                    data-toggle="dropdown"
                                    data-target="#"
                                >
                                    Products
                                </Link>
                                <div className={"dropdown-menu bg-default border-top-0 w-75 top-auto"}>
                                    <div className="container">
                                        {!mobile ? (
                                            <React.Fragment>
                                                <div className="row mega-menu">
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Compute
                                                        </h5>
                                                        <Link className="dropdown-item" to="/elasticcomputeservice">
                                                            Elastic Compute Server
                                                        </Link>
                                                        <Link className="dropdown-item" to="/imagemanagementservice">
                                                            Image Management Service
                                                        </Link>
                                                        <Link className="dropdown-item" to="/autoscaling">
                                                            Auto Scaling
                                                        </Link>
                                                        <Link className="dropdown-item" to="/kubernetesclusterservice">
                                                            Kubernetes Cluster Service
                                                        </Link>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Storage
                                                        </h5>
                                                        <Link className="dropdown-item" to="/elasticvolumeservice">
                                                            Elastic Volume Service
                                                        </Link>
                                                        <Link className="dropdown-item" to="/premiumbackupservice">
                                                            Premium Backup Service
                                                        </Link>
                                                        <Link className="dropdown-item" to="/objectstorageservice">
                                                            Object Storage Service
                                                        </Link>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Network
                                                        </h5>
                                                        <Link
                                                            title="JavaScript Library"
                                                            className="dropdown-item"
                                                            to="/vpc"
                                                        >
                                                            Virtual Private Cloud
                                                        </Link>
                                                        <Link className="dropdown-item" to="/directconnect">
                                                            Direct Connect
                                                        </Link>
                                                        <Link className="dropdown-item" to="/elasticip">
                                                            Elastic IP
                                                        </Link>
                                                        <Link className="dropdown-item" to="/virtualprivatenetwork">
                                                            Virtual Private Network
                                                        </Link>
                                                        <Link className="dropdown-item" to="/loadbalancer">
                                                            Load Balancer
                                                        </Link>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Security
                                                        </h5>
                                                        <Link className="dropdown-item" to="/antiddos">
                                                            Anti DDOS
                                                        </Link>
                                                        <Link className="dropdown-item" to="/webapplicationfirewall">
                                                            Web Application Firewall
                                                        </Link>
                                                        <Link className="dropdown-item" to="/firewall">
                                                            Firewall
                                                        </Link>
                                                        <Link className="dropdown-item" to="/directoryservice">
                                                            Directory Service
                                                        </Link>
                                                        <Link className="dropdown-item" to="/endpointprotection">
                                                            Endpoint Protection
                                                        </Link>
                                                        <Link className="dropdown-item" to="/encryption">
                                                            Encryption
                                                        </Link>
                                                    </div>
                                                </div>

                                                <div className="row mega-menu">
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Collaboration And Communication Suite
                                                        </h5>
                                                        <Link className="dropdown-item" to="/hostedexchange">
                                                            Hosted Exchange
                                                        </Link>
                                                        <Link className="dropdown-item" to="/hostedsharepoint">
                                                            Hosted Sharepoint
                                                        </Link>
                                                        <Link className="dropdown-item" to="/cloudemailsecurity">
                                                            Cloud Email Security
                                                        </Link>
                                                        <Link className="dropdown-item" to="/cloudemailarchive">
                                                            Cloud Email Archive
                                                        </Link>
                                                        <Link className="dropdown-item" to="/office365">
                                                            Office 365
                                                        </Link>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5></h5>
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Database
                                                        </h5>
                                                        <Link className="dropdown-item" to="microsqlserver">
                                                            Microsoft® SQL Server{" "}
                                                        </Link>
                                                        <Link className="dropdown-item" to="mysql">
                                                            MYSQL®
                                                        </Link>
                                                        <Link className="dropdown-item" to="oracle">
                                                            Oracle®
                                                        </Link>
                                                        <Link className="dropdown-item" to="saphana">
                                                            SAP® HANA
                                                        </Link>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <div className="header-mobile-scroll mega-menu">
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Compute
                                                        </h5>
                                                        <a className="dropdown-item" href="/elasticcomputeservice">
                                                            Elastic Compute Server
                                                        </a>
                                                        <a className="dropdown-item" href="/imagemanagementservice">
                                                            Image Management Service
                                                        </a>
                                                        <a className="dropdown-item" href="/autoscaling">
                                                            Auto Scaling
                                                        </a>
                                                        <a className="dropdown-item" href="/kubernetesclusterservice">
                                                            Kubernetes Cluster Service
                                                        </a>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Storage
                                                        </h5>
                                                        <a className="dropdown-item" href="/elasticvolumeservice">
                                                            Elastic Volume Service
                                                        </a>
                                                        <a className="dropdown-item" href="/premiumbackupservice">
                                                            Premium Backup Service
                                                        </a>
                                                        <a className="dropdown-item" href="/objectstorageservice">
                                                            Object Storage Service
                                                        </a>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Network
                                                        </h5>
                                                        <a
                                                            title="JavaScript Library"
                                                            className="dropdown-item"
                                                            href="/vpc"
                                                        >
                                                            Virtual Private Cloud
                                                        </a>
                                                        <a className="dropdown-item" href="/directconnect">
                                                            Direct Connect
                                                        </a>
                                                        <a className="dropdown-item" href="/elasticip">
                                                            Elastic IP
                                                        </a>
                                                        <a className="dropdown-item" href="/virtualprivatenetwork">
                                                            Virtual Private Network
                                                        </a>
                                                        <a className="dropdown-item" href="/loadbalancer">
                                                            Load Balancer
                                                        </a>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Security
                                                        </h5>
                                                        <a className="dropdown-item" href="/antiddos">
                                                            Anti DDOS
                                                        </a>
                                                        <a className="dropdown-item" href="/webapplicationfirewall">
                                                            Web Application Firewall
                                                        </a>
                                                        <a className="dropdown-item" href="/firewall">
                                                            Firewall
                                                        </a>
                                                        <a className="dropdown-item" href="/directoryservice">
                                                            Directory Service
                                                        </a>
                                                        <a className="dropdown-item" href="/endpointprotection">
                                                            Endpoint Protection
                                                        </a>
                                                        <a className="dropdown-item" href="/encryption">
                                                            Encryption
                                                        </a>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Collaboration And Communication Suite
                                                        </h5>
                                                        <a className="dropdown-item" href="/hostedexchange">
                                                            Hosted Exchange
                                                        </a>
                                                        <a className="dropdown-item" href="/hostedsharepoint">
                                                            Hosted Sharepoint
                                                        </a>
                                                        <a className="dropdown-item" href="/cloudemailsecurity">
                                                            Cloud Email Security
                                                        </a>
                                                        <a className="dropdown-item" href="/cloudemailarchive">
                                                            Cloud Email Archive
                                                        </a>
                                                        <a className="dropdown-item" href="/office365">
                                                            Office 365
                                                        </a>
                                                    </div>
                                                    <div className=" col-md-3">
                                                        <h5 className="border border-top-0 border-right-0 border-left-0">
                                                            Database
                                                        </h5>
                                                        <a className="dropdown-item" href="microsqlserver">
                                                            Microsoft® SQL Server{" "}
                                                        </a>
                                                        <a className="dropdown-item" href="mysql">
                                                            MYSQL®
                                                        </a>
                                                        <a className="dropdown-item" href="oracle">
                                                            Oracle®
                                                        </a>
                                                        <a className="dropdown-item" href="saphana">
                                                            SAP® HANA
                                                        </a>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item dropdown ">
                                <Link
                                    to="#"
                                    onClick={() =>
                                        this.setState({
                                            showSolutions: mobile ? !this.state.showSolutions : this.state.showSolutions
                                        })
                                    }
                                    className={
                                        !showSolutions
                                            ? "nav-link text-white  dropdown-toggle"
                                            : " text-white  dropdown-toggle"
                                    }
                                    data-toggle="dropdown"
                                    data-target="#"
                                >
                                    Solutions & Services
                                </Link>
                                <div className="dropdown-menu bg-default border-top-0 w-100 padding-partner">
                                    <div className="mega-menu">
                                        {/* <p className="partner-item"><Link className="partner-item cursor-not-allowed" >DETASAD Cloud Manager (DCM)</Link></p> */}
                                        <p className="partner-item">
                                            <Link className="partner-item" to="/privatecloud">
                                                Private Cloud
                                            </Link>
                                        </p>
                                        <p className="partner-item">
                                            <Link className="partner-item" to="/cloudbackupandrecovery">
                                                Cloud Backup & Recovery
                                            </Link>
                                        </p>
                                        <p className="partner-item">
                                            <Link className="partner-item" to="/drasaservice">
                                                DRaaS
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    onClick={() =>
                                        this.setState({
                                            showPartners: mobile ? !this.state.showPartners : this.state.showPartners
                                        })
                                    }
                                    to="#"
                                    className={
                                        !showPartners
                                            ? "nav-link text-white  dropdown-toggle"
                                            : " text-white  dropdown-toggle"
                                    }
                                    data-toggle="dropdown"
                                    data-target="#"
                                >
                                    Partners
                                </Link>
                                <div className="dropdown-menu bg-default border-top-0 w-100 padding-partner">
                                    <div className="mega-menu">
                                        <Link to={"/technologypartners"} className="partner-item d-block ">
                                            Technology Partners
                                        </Link>
                                        <Link
                                            to={{ pathname: process.env.REACT_APP_PARTNERS }}
                                            target="_blank"
                                            className="partner-item d-block mt-3 "
                                        >
                                            Partner Login
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link text-white"
                                    to={{ pathname: process.env.REACT_APP_CONTACTUS }}
                                    target="_blank"
                                >
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                        {/* <div className="right-buttons mobile-hide">
                            <button
                                className="btn btn-sm signin-button"
                                onClick={() => window.open(process.env.REACT_APP_CONSOLE, "_blank")}
                            >
                                Console
                            </button>
                            <button
                                className="btn btn-sm signin-button"
                                onClick={() => window.open(process.env.REACT_APP_SIGNUP, "_blank")}
                            >
                                Sign Up
                            </button>
                            <button
                                className="btn btn-sm signin-button bordered"
                                onClick={() => window.open(process.env.REACT_APP_SIGNUP, "_blank")}
                            >
                                Sign In
                            </button>
                        </div> */}
                    </div>
                </nav>
            </React.Fragment>
        );
    }
}

export default withRouter(Header);
